import { render, staticRenderFns } from "./v-order-submit-price.vue?vue&type=template&id=6f381697&scoped=true"
import script from "./v-order-submit-price.vue?vue&type=script&lang=js"
export * from "./v-order-submit-price.vue?vue&type=script&lang=js"
import style0 from "./v-order-submit-price.vue?vue&type=style&index=0&id=6f381697&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f381697",
  null
  
)

export default component.exports